export default __webpack_public_path__ + "static/media/claim-reward.4bdd0c7c.png";